import { IonicModule } from '@ionic/angular';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageCropperModalComponent } from './image-cropper/image-cropper.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { MenuSelectModalComponent } from './menu-select/menu-select.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectManagerProfileModalComponent } from './select-manager-profile/select-manager-profile.component';
import { SelectFileUploadModalComponent } from './select-file-upload/select-file-upload.component';
import { ComponentsModule } from '@components/components.module';
import { CameraModalComponent } from './camera/camera.component';
import { PreviewFileModalComponent } from './preview-file/preview-file.component';
import { ItemSelectModalComponent } from './item-select/item-select.component';
import { PresentIframeComponent } from './present-iframe/present-iframe.component';
import { PipesModule } from '../pipes/pipes.module';
import { ObservationTextComponent } from './observation-text/observation-text.component';
import { IssueCardComponent } from './issue-card/issue-card.component';
import { SimpleListModalComponent } from './simple-list/simple-list.component';
import { DirectivesModule } from '@directives/directives.module';
import { SelectMerchantCampaignModalComponent } from './select-merchant-campaign/select-merchant-campaign.component';
import { ConsumptionChoiceModalComponent } from './consumption-choice/consumption-choice.component';
import { NotificationModalComponent } from './notification/notification.component';
import { SelectRepresentativeProfileComponent } from './select-representative-profile/select-representative-profile.component';
import { BlacklistAddItemComponent } from './blacklist-add-item/blacklist-add-item.component';
import { MerchantIdentificationModalComponent } from './merchant-identification/merchant-identification.component';
import { QrCodeModule } from 'ng-qrcode';
import { ViewDocumentModalComponent } from './view-document/view-document.component';
import { ConfigureModuleModalComponent } from './configure-module/configure-module.component';
import { AccountPageRoutingModule } from "@pages/account/account-routing.module";
import { ImportHouseholdersUsersComponent } from './import-householders-users/import-householders-users.component';
import { UploadRequestedCardsComponent } from './upload-requested-cards/upload-requested-cards.component';
import { ScrollingModule } from "@angular/cdk/scrolling";
import { ClaimAwardModalComponent } from './claim-award/claim-award.component';

const components = [
    ImageCropperModalComponent,
    // MenuSelectModalComponent,
    ItemSelectModalComponent,
    SelectManagerProfileModalComponent,
    SelectFileUploadModalComponent,
    CameraModalComponent,
    PreviewFileModalComponent,
    PresentIframeComponent,
    ObservationTextComponent,
    IssueCardComponent,
    SimpleListModalComponent,
    SelectMerchantCampaignModalComponent,
    ConsumptionChoiceModalComponent,
    NotificationModalComponent,
    SelectRepresentativeProfileComponent,
    BlacklistAddItemComponent,
    MerchantIdentificationModalComponent,
    ViewDocumentModalComponent,
    ConfigureModuleModalComponent,
    ImportHouseholdersUsersComponent,
    UploadRequestedCardsComponent,
    ClaimAwardModalComponent
];

@NgModule({
    declarations: [components],
    exports: [components],
    imports: [
        CommonModule,
        IonicModule,
        ImageCropperModule,
        ReactiveFormsModule,
        ComponentsModule,
        PipesModule,
        DirectivesModule,
        QrCodeModule,
        AccountPageRoutingModule,
        ScrollingModule
    ]
})
export class ModalsModule { }
